<template>
  <div
    v-if="!$route.params.homeSlug || home.slug"
    id="app"
    class="app"
    :class="{ '-user': $route.meta.userRoute }"
  >
    <navigation />
    <router-view :key="$route.fullPath" />
    <v-footer />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import VFooter from "@/components/Footer.vue";
import { mapActions, mapState } from "vuex";

export default {
  metaInfo() {
    let title = "";
    return {
      title,
      titleTemplate: title
        ? "%s | Veteran Friendly Framework"
        : "Veteran Friendly Framework",
    };
  },
  components: {
    Navigation,
    VFooter,
  },
  mounted() {
    if (this.$route.params.homeSlug) {
      this.fetchHome(this.$route.params.homeSlug);
    }
  },
  methods: {
    ...mapActions(["fetchHome"]),
  },
  computed: {
    ...mapState(["home"]),
  },
  watch: {
    "$route.params.homeSlug"(newHome) {
      if (newHome) {
        this.fetchHome(this.$route.params.homeSlug);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  &.-user {
    background-color: #6b2377;
  }
}
</style>
